import { useState, useRef } from "react";
import Header from "../Common/Header";
import Footer from "../Common/Footer";

import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import { ApiContext } from "../Context/Context";
import { use, useContext, useEffect } from "react";
import {
  getRecords,
  PostRecords,
  uploadMultipleFiles,
} from "../Services/ApiCall";
import FeaturedProperty from "../Common/FeaturedProperties";
import ProjectsComp from "../Common/Projects";
import NearByProperties from "../Common/NearByProperties";
import {
  LoggedInUserID,
  LoggedInUserName,
  AUTH_KEY,
  BaseUrl,
  apiUrl_dialerp,
  setLogindata,
  setUserdata,
} from "../Services/Urls";
import FilterParams from "../Classes/FilterParams";
import { useNavigate } from "react-router-dom";

import { TailSpin } from "react-loader-spinner";
import SelectDialog from "../Common/SelectDialog ";
import AmenitiesDialog from "../Common/AmenitiesDialog";
import { decryptOtp } from "../Services/Helper";
import {
  callApi,
  makeApiRequest,
  callAzureOpenAI,
} from "../Services/ApiService";

import { toast } from "react-toastify";
import SucessDialog from "../Common/Dialog/SucessDialog";
import {
  formatIndianAmount,
  removeSpecialCharacters,
} from "../Services/Helper";

/* Styles */

const buttons = ["Owner", "Broker/Builder"];
const buttonss = ["Residential", "Commercial"];
const buttonsss = ["Rent", "Sell", "PG/Co-Living"];

function PostProperty() {
  const location = useLocation();

  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);
  const ListingID = params.get("id") || "";
  const TabID = params.get("tabid") || "";
  const stepflag = params.get("step") || "";

  const [step, setStep] = useState(stepflag!= "" ? parseInt(stepflag) : 1);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [postedID, setPostedID] = useState(null);
  const [stepLogin, setStepLogin] = useState(1);
  const {
    logindata,
    setlogindata,
    userData,
    setuserData,
    CityData,

    coordinates,

    Locality,

    Area,
  } = useContext(ApiContext);

  const maxStep = ListingID ? 6 : 5;

  const nextStep = () => {
    setStep((prev) => (prev < maxStep ? prev + 1 : prev));
    //window.scrollTo(0, 0);
  };
  const prevStep = () =>{
step > 1 && setStep(step - 1);
 //window.scrollTo(0, 0);

  } 
  const STEPS = [
    "Location",
    "Category",
    "Property Info",
    "Basic Details",
    "Map Location",
    ...(ListingID !== "" ? ["Media Gallery"] : []),
  ];

  const [BHKData, setBHKData] = useState([]);
  const [PropertyType, setPropertyType] = useState([]);
  const [Vertical, setVertical] = useState([]);
  const [AreaunitData, setAreaunitData] = useState([]);
  const [FurnishingData, setFurnishingData] = useState([]);
  const [ConstructionStatusData, setConstructionStatusData] = useState([]);
  const [ChooseProperty, setChooseProperty] = useState([]);

  const [PostedByData, setPostedByData] = useState([
    { id: 1, name: "Owner", colorCode: "#000000" },
    { id: 2, name: "Agent", colorCode: "#000000" },
  ]);
  const [selectedPostedByData, setselectedPostedByData] = useState({
    id: 1,
    name: "Owner",
    colorCode: "#000000",
  });

  const [locationHubData, setlocationHubData] = useState([
    { id: 1, name: "Mall", colorCode: "#000000" },
    { id: 2, name: "Commercial Project", colorCode: "#000000" },
    { id: 3, name: "Residential Project", colorCode: "#000000" },
    { id: 4, name: "Retail Complex/Building", colorCode: "#000000" },
    { id: 5, name: "Market/High Street", colorCode: "#000000" },
    { id: 6, name: "Others", colorCode: "#000000" },
  ]);
  const [selectedlocationHubData, setselectedlocationHubData] = useState({
    id: 2,
    name: "Commercial Project",
    colorCode: "#000000",
  });
  const [ownershipData, setownershipData] = useState([
    { id: 1, name: "Freehold", colorCode: "#000000" },
    { id: 2, name: "Leasehold", colorCode: "#000000" },
    { id: 3, name: "Power of Attorney", colorCode: "#000000" },
    { id: 4, name: "Cooperative Society", colorCode: "#000000" },
  ]);
  const [selectedownershipData, setselectedownershipData] = useState({
    id: 1,
    name: "Freehold",
    colorCode: "#000000",
  });
  const [preRented, setpreRented] = useState([
    { id: 1, name: "Yes", colorCode: "#000000" },
    { id: 2, name: "No", colorCode: "#000000" },
  ]);
  const [selectedpreRented, setselectedpreRented] = useState(null);
  const [PGName, setPGName] = useState("");
  const [PGisFor, setPGisFor] = useState([
    { id: 1, name: "Boys", colorCode: "#000000" },
    { id: 2, name: "Girls", colorCode: "#000000" },
  ]);
  const [selectedPGisFor, setselectedPGisFor] = useState(null);
  const [bestSuitedFor, setbestSuitedFor] = useState([
    { id: 1, name: "Students", colorCode: "#000000" },
    { id: 2, name: "Professionals", colorCode: "#000000" },
  ]);
  const [selectedbestSuitedFor, setselectedbestSuitedFor] = useState({
    id: 1,
    name: "Students",
    colorCode: "#000000",
  });
  const [MealsAvailable, setMealsAvailable] = useState([
    { id: 1, name: "Yes", colorCode: "#000000" },
    { id: 2, name: "No", colorCode: "#000000" },
  ]);
  const [selectedMealsAvailable, setselectedMealsAvailable] = useState(null);
  const [Noticeperiod, setNoticeperiod] = useState("");
  const [LockinPeriod, setLockinPeriod] = useState("");
  const [RoomTypeData, setRoomTypeData] = useState([]);
  const [selectedRoomTypeData, setselectedRoomTypeData] = useState([]);
  const [MealsOfferingData, setMealsOfferingData] = useState([]);
  const [selectedMealsOfferingData, setselectedMealsOfferingData] = useState(
    [],
  );
  const [CommonAreaData, setCommonAreaData] = useState([]);
  const [selectedCommonAreaData, setselectedCommonAreaData] = useState([]);
  const [totalBeds, settotalBeds] = useState("");

  const [SocietyAmenities, setSocietyAmenities] = useState([]);
  const [selected_SocietyAmenities, setSelected_SocietyAmenities] = useState(
    [],
  );
  const [PropertyAmenities, setPropertyAmenities] = useState([]);
  const [selected_PropertyAmenities, setSelected_PropertyAmenities] = useState(
    [],
  );
  const [facingData, setFacingData] = useState([
    { id: 1, name: "North" },
    { id: 2, name: "South" },
    { id: 3, name: "East" },
    { id: 4, name: "West" },
    { id: 5, name: "North-East" },
    { id: 6, name: "North-West" },
    { id: 7, name: "South-East" },
    { id: 8, name: "South-West" },
  ]);

  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedLocality, setSelectedLocality] = useState(null);
  const [selectedArea, setSelectedArea] = useState(null);
  const [selectedBHK, setSelectedBHK] = useState(null);
  const [selectedAreaUnit, setSelectedAreaUnit] = useState(null);
  const [selectedFurnishing, setselectedFurnishing] = useState(null);

  const [selectedPropertyType, setselectedPropertyType] = useState({
    _id: 1,
    PropertyType: "Residential",
    PropertyTypeID: 1,
    cDt: "04-Sep-2025 11:27:48",
  });
  const [Selected_ChooseProperty, setSelected_ChooseProperty] = useState(null);
  const [selectedVertical, setselectedVertical] = useState({
    _id: 5,
    Vertical: "Sale",
    VerticalID: 1,
    cDt: "09-Sep-2025 15:00:08",
  });
  const [selectedFacing, setselectedFacing] = useState(null);
  const [selected_constructionStatus, setselected_constructionStatus] =
    useState(null);
  const [buildupArea, setbuildupArea] = useState("");
  const [carpetArea, setcarpetArea] = useState("");
  const [price, setprice] = useState("");
  const [expectedReturn, setexpectedReturn] = useState("");
  const [securityDeposit, setsecurityDeposit] = useState("");
  const formatDate = (date) => {
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "2-digit",
    }).format(date);
  };

  const [availableDt, setAvailableDt] = useState(formatDate(new Date()));
  const [KeyHighlights, setKeyHighlights] = useState("");
  const [floorNo, setfloorNo] = useState("");
  const [Description, setDescription] = useState("");
  const [coverImage, setCoverImage] = useState("");
  const [BathroomImage, setBathroomImage] = useState("");
  const [KitchenImage, setKitchenImage] = useState("");
  const [BedroomImage, setBedroomImage] = useState("");
  const [BalconyImage, setBalconyImage] = useState("");
  const [LivingRoomImage, setLivingRoomImage] = useState("");
  const [DiningRoomImage, setDiningRoomImage] = useState("");
  const [ElevationImage, setElevationImage] = useState("");
  const [LocalityImage, setLocalityImage] = useState("");
  const [OtherImage, setOtherImage] = useState("");
  const [floorPlansImage, setfloorPlansImage] = useState("");
  const [videoLink, setvideoLink] = useState("");
  const [totalFloors, settotalFloors] = useState("");
  const [propertyAgeFields, setPropertyAgeFields] = useState([
    {
      id: 1,
      name: "Under Construction",
      colorCode: "#000000",
    },
    {
      id: 2,
      name: "1-5 Years",
      colorCode: "#000000",
    },
    {
      id: 3,
      name: "5-10 Years",
      colorCode: "#000000",
    },
    {
      id: 4,
      name: "10-15 Years",
      colorCode: "#000000",
    },
    {
      id: 5,
      name: "15+ Years",
      colorCode: "#000000",
    },
  ]);

  const [selectedPropertyAge, setSelectedPropertyAge] = useState(null);

  const [open, setOpen] = useState(false);

  const [openAmenitiesDialog, setOpenAmenitiesDialog] = useState(false);
  const [value, setValue] = useState("");
  const [dataFlag, setdataFlag] = useState(1);
  const [dataFlag_Amenities, setdataFlag_Amenities] = useState(1);
  const [listingDetails, setlistingDetails] = useState(null);
  const options = ["Faridabad", "Noida", "Jaipur", "Delhi", "Ghaziabad"];
  const [Loading, setLoading] = useState(false);

  const handleSelectClick = (e) => {
    e.preventDefault(); // prevent default dropdown
    setOpen(true);
  };

  const handleOptionSelect = (option) => {
    setValue(option);
    setOpen(false);
  };

  useEffect(() => {
    getPropertyType();
    getVerticalType();
    getBHKType();
    getFurnishType();
    getAreaUnit();
    getConstructionStatus();
    getpropertyAmenities();
    getSocietyAmenities();
    getRoomData();
    getMealsData();

    if (ListingID != "" && ListingID != null && ListingID != undefined)
      getListingDetails(ListingID);
  }, []);

  useEffect(() => {
    getChoosePropertyType();
  }, [selectedVertical, selectedPropertyType]);

  useEffect(()=>{

    
    window.scrollTo(0, 0);
    


  },[step])

  const getListingDetails = (id) => {
    getRecords(TabID, 1, `{ListingID: { $in: [${id}] }}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setlistingDetails(data?.response?.records[0] || null);

          let product = data?.response?.records[0] || null;

          setselectedPropertyType({
            _id: 1,
            PropertyType: product.PropertyType || "",
            PropertyTypeID: product.PropertyTypeID || 0,
            cDt: "04-Sep-2025 11:27:48",
          });

          // VERTICAL
          setselectedVertical({
            _id: 5,
            Vertical: product.Vertical || "",
            VerticalID: product.VerticalID || 0,
            cDt: "09-Sep-2025 15:00:08",
          });

          // CITY / LOCATION
          setSelectedCity({
            City: product.City || "",
            CityID: product.CityID || 0,
            State: product.State || "",
            StateID: product.StateID || "",
            Country: product.Country || "",
            CountryID: product.CountryID || "",
            CityAlias: product.CityAlias || "",
          });

          setSelectedLocality({
            Locality: product.Locality || "",
            LocalityID: product.LocalityID || 0,

            City: product.City || "",
            CityID: product.CityID || 0,
            State: product.State || "",
            StateID: 0,
            Country: product.Country || "",
            CountryID: 0,
            CityAlias: product.CityAlias,

            cDt: product.cDt || "",
            Coordinate: null,
          });

          setSelectedArea({
            SubArea: product.Society || "",
            SubAreaID: product.SocietyID || 0,

            Locality: product.Locality || "",
            LocalityID: product.LocalityID || 0,
            City: product.City || "",
            CityID: product.CityID || 0,
            State: product.State || "",
            StateID: 0,
            Country: product.Country || "",
            CountryID: 0,
            CityAlias: product.CityAlias || "",

            cDt: "",
            Coordinate: null,
          });

          // BHK
          setSelectedBHK({
            BHKUnit: product.BHK || "",
            BHKID: product.BHKID || 0,
          });

          //area unit
          setSelectedAreaUnit({
            UOMID: 2,
            UOMName: "sq. ft.",
          });

          // FURNISHING
          setselectedFurnishing({
            FurnishType: product.FurnishType || "",
            FurnishID: product.FurnishID || 0,
          });

          // CONSTRUCTION STATUS
          setselected_constructionStatus({
            ConstructionStatus: product.ConstructionStatus || "",
            ConstructionStatusID: product.ConstructionStatusID || 0,
          });

          // AREA
          setbuildupArea(product.BuiltUpArea?.toString() || "");
          setDescription(product.Description || "");

          // PRICE / RENT (same logic as Android)
          setprice(
            product.PropertyTypeID === 1 || product.PropertyTypeID === 2
              ? product.VerticalID === 2
                ? product.MonthlyRent?.toString() || ""
                : product.Price?.toString() || ""
              : product.Price?.toString() || "",
          );

          // SECURITY DEPOSIT
          setsecurityDeposit(
            product.PropertyTypeID === 1 && product.VerticalID === 3
              ? product.R1_SecurityDeposit?.toString() || ""
              : product.SecurityDeposit?.toString() || "",
          );

          // FLOORS
          setfloorNo(product.FloorNo?.toString() || "");
          settotalFloors(product.TotalFloor?.toString() || "");

          // FACING
          setselectedFacing(product.Facing || "");

          // DATES
          setAvailableDt(product.AvailableFrom || "");

          // PG DATA
          setPGName(product.PGName || "");
          settotalBeds((product.TotalBeds || "").toString());
          setNoticeperiod((product.NoticePeriod || "").toString());
          setLockinPeriod((product.LockInPeriod || "").toString());
          setexpectedReturn((product.ExpectedROI || "").toString());

          // PROPERTY AGE
          setSelectedPropertyAge({
            id: 2,
            name: product.PropertyAge || "",
            colorCode: "#000000",
          });

          // LOCATION HUB
          setselectedlocationHubData({
            id: 2,
            name: product.LocationHub || "",
            colorCode: "#000000",
          });

          // OWNERSHIP
          setselectedownershipData({
            id: 1,
            name: product.Ownership || "",
            colorCode: "#000000",
          });

          // PG OPTIONS
          setselectedPGisFor({
            id: 1,
            name: product.PGisfor || "",
            colorCode: "#000000",
          });

          setselectedpreRented({
            id: 1,
            name: product.Isitpreleasedprerented || "",
            colorCode: "#000000",
          });

          setselectedbestSuitedFor({
            id: 1,
            name: product.BestSuitedfor || "",
            colorCode: "#000000",
          });

          setselectedMealsAvailable({
            id: 1,
            name: product.MealsAvailable || "",
            colorCode: "#000000",
          });

          setCoverImage(product.Images || "");
          setBathroomImage(product.BathroomImage || "");
          setKitchenImage(product.KitchenImage || "");
          setElevationImage(product.ElevationImage || "");
          setBedroomImage(product.BedroomImage || "");
          setBalconyImage(product.BalconyImage || "");
          setLivingRoomImage(product.LivingroomImage || "");
          setLocalityImage(product.LocalityImage || "");
          setfloorPlansImage(product.FloorPlanImage || "");
          setDiningRoomImage(product.DiningAreaImage || "");
          setOtherImage(product.Others || "");
          setvideoLink(product.Videos || "");

          // LIST DATA
          setSelected_SocietyAmenities(product.PropertyAmenities || []);
          setSelected_PropertyAmenities(product.UnitFurnishingtitle || []);
          setselectedRoomTypeData(product.R1_RoomType || []);
          setselectedMealsOfferingData(product.MealsOfferings || []);
          setselectedCommonAreaData(product.CommonAreas || []);

          getChoosePropertyType(data?.response?.records[0]);

          // setLoading(false);
        } else {
          // setLoading(false);
          console.log("Error in fetching featured properties", data);
        }
      } else {
        //  setLoading(false);
      }
    });
  };

  const getChoosePropertyType = (listingDetails = null) => {
    getRecords(
      411,
      100,
      `{PropertyTypeID: { $in: [${selectedPropertyType?.PropertyTypeID}] },VerticalID: { $in: [${selectedVertical?.VerticalID}] }}`,
      1,
      "",
      (data) => {
        if (data != null) {
          if (data?.hasErrors === false && data?.response?.records != null) {
            setChooseProperty(data?.response?.records || []);

            if (
              Selected_ChooseProperty == null &&
              ListingID != "" &&
              ListingID != null &&
              ListingID != undefined &&
              listingDetails != null
            ) {
              console.log("check run ", listingDetails);
              const matchedProperty = data?.response?.records?.find(
                (item) =>
                  item.ChoosePropertyID === listingDetails?.ChoosePropertyID,
              );

              setSelected_ChooseProperty({
                _id: 1,
                ChooseProperty: listingDetails?.ChooseProperty || "",
                PropertyType: listingDetails?.PropertyType || "",
                PropertyTypeID: listingDetails?.PropertyTypeID || 0,
                Vertical: listingDetails?.Vertical || "",
                VerticalID: listingDetails?.VerticalID || 0,
                ChoosePropertyID: listingDetails?.ChoosePropertyID || 0,
                cDt: "04-Sep-2025 11:27:48",
                BHK: matchedProperty?.BHK || "",
                BHKID: matchedProperty?.BHKID || 0,
              });
            }
          } else {
            setChooseProperty([]);
            console.log("Error in fetching featured properties", data);
          }
        }
      },
    );
  };

  const getPropertyType = () => {
    getRecords(391, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setPropertyType(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getVerticalType = () => {
    getRecords(392, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setVertical(data?.response?.records || []);
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getBHKType = () => {
    getRecords(394, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setBHKData(data?.response?.records || []);
        } else {
          setBHKData([]);
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getFurnishType = () => {
    getRecords(395, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setFurnishingData(data?.response?.records || []);
        } else {
          setFurnishingData([]);
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getAreaUnit = () => {
    getRecords(407, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setAreaunitData(data?.response?.records || []);
        } else {
          setAreaunitData([]);
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getpropertyAmenities = () => {
    getRecords(397, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setPropertyAmenities(data?.response?.records || []);
        } else {
          setPropertyAmenities([]);
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getSocietyAmenities = () => {
    getRecords(396, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setSocietyAmenities(data?.response?.records || []);
        } else {
          setSocietyAmenities([]);
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getConstructionStatus = () => {
    getRecords(406, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setConstructionStatusData(data?.response?.records || []);
        } else {
          setConstructionStatusData([]);
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };
  const getRoomData = () => {
    getRecords(421, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setRoomTypeData(data?.response?.records || []);
        } else {
          setRoomTypeData([]);
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getMealsData = () => {
    getRecords(422, 100, `{}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setMealsOfferingData(data?.response?.records || []);
        } else {
          setMealsOfferingData([]);
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const PostPropertyData = () => {
    const bhkText = selectedBHK?.BHKUnit ? `${selectedBHK.BHKUnit} ` : "";
    const propertyText = Selected_ChooseProperty?.ChooseProperty || "Property";
    const locality = selectedLocality?.Locality || "";
    const city = selectedCity?.City || "";

    let seoTitle = "";

    if (selectedVertical?.VerticalID === 1) {
      // Sale
      seoTitle = `${bhkText}${propertyText} for Sale in ${locality}, ${city}`;
    } else if (selectedVertical?.VerticalID === 2) {
      // Rent
      seoTitle = `${bhkText}${propertyText} for Rent in ${locality}, ${city}`;
    } else if (selectedVertical?.VerticalID === 3) {
      // PG / Co-living
      seoTitle = `${propertyText} PG / Co-living in ${locality}, ${city}`;
    }

    const postData = [
      {
        ...(ListingID ? { ListingID } : {}),
        City: selectedCity?.City,
        CityAlias: selectedCity?.CityAlias,
        PropertyType: selectedPropertyType?.PropertyType,
        PropertyTypeID: selectedPropertyType?.PropertyTypeID,
        Vertical: selectedVertical?.Vertical,
        VerticalID: selectedVertical?.VerticalID,
        CityID: selectedCity?.CityID,
        ChooseProperty: Selected_ChooseProperty?.ChooseProperty,
        ChoosePropertyID: Selected_ChooseProperty?.ChoosePropertyID,
        Society: selectedArea?.SubArea,
        SocietyID: selectedArea?.SubAreaID,
        Locality: selectedLocality?.Locality,
        LocalityID: selectedLocality?.LocalityID,
        State: selectedCity?.State,
        Country: selectedCity?.Country,

        Title: seoTitle,
        Description: removeSpecialCharacters(Description),
        KeyHighlights: removeSpecialCharacters(KeyHighlights),

        BHK: selectedBHK?.BHKUnit,
        BHKID: selectedBHK?.BHKID,
        BuiltUpArea: buildupArea,
        UOMName: selectedAreaUnit?.UOMName,
        UOMID: selectedAreaUnit?.UOMID,

        FurnishType: selectedFurnishing?.FurnishType,
        FurnishID: selectedFurnishing?.FurnishID,

        ...(selected_PropertyAmenities?.length > 0 && {
          UnitFurnishingtitle: selected_PropertyAmenities,
        }),

        ...(selected_SocietyAmenities?.length > 0 && {
          PropertyAmenities: selected_SocietyAmenities,
        }),

        Price: price,

        ConstructionStatus: selected_constructionStatus?.ConstructionStatus,
        ConstructionStatusID: selected_constructionStatus?.ConstructionStatusID,
        LocationHub: selectedlocationHubData?.name,
        LocationHubID: selectedlocationHubData?.id,
        Ownership: selectedownershipData?.name,
        OwnershipID: selectedownershipData?.id,
        Isitpreleasedprerented: selectedpreRented?.name,
        IsitpreleasedprerentedID: selectedpreRented?.id,
        PGName: PGName,
        TotalBeds: totalBeds,
        PGisfor: selectedPGisFor?.name,
        BestSuitedfor: selectedbestSuitedFor?.name,
        MealsAvailable: selectedMealsAvailable?.name,
        PgisforID: selectedPGisFor?.id,
        BestSuitedforID: selectedbestSuitedFor?.id,
        MealsAvailableID: selectedMealsAvailable?.id,
        CommonArea: selectedCommonAreaData,
        ...(selectedMealsOfferingData?.length > 0 && {
          MealsOfferings: selectedMealsOfferingData,
        }),
        NoticePeriod: Noticeperiod,
        LockInPeriod: LockinPeriod,
        CommonAreas: selectedCommonAreaData,
        R1_SecurityDeposit: securityDeposit,
        R1_RoomType: selectedRoomTypeData,

        MonthlyRent: price,
        SecurityDeposit: securityDeposit,
        AvailableFrom: availableDt,

        CarpetArea: "",
        ExpectedROI: expectedReturn,
        PropertyAge: selectedPropertyAge?.name,
        AgeofProperty: selectedPropertyAge?.name,

        SellerName: userData?.User,
        SellerID: userData?.UserID,
        SellerMobile: userData?.Mobile,
        Profile: userData?.Profile,
        ProfileID: userData?.ProfileID,

        Status: "In Review",
        StatusID: "1",

        Images: coverImage,
        BathroomImage: BathroomImage,
        KitchenImage: KitchenImage,
        ElevationImage: ElevationImage,
        BedroomImage: BedroomImage,
        BalconyImage: BalconyImage,
        LivingroomImage: LivingRoomImage,
        LocalityImage: LocalityImage,
        FloorPlanImage: floorPlansImage,
        DiningAreaImage: DiningRoomImage,
        Others: OtherImage,
        Videos: "",

        TotalFloor: totalFloors,
        FloorNo: floorNo,
        Facing: selectedFacing?.name,

        PostedBy: selectedPostedByData?.name,
        PostedByID: selectedPostedByData?.id,
        Featured:"N",
        FeaturedID : 2,
       

        ...(coordinates && {
    Coordinates: [coordinates.latitude, coordinates.longitude],
  }),
      },
    ];

    const tabID =
      selectedPropertyType?.PropertyTypeID === 1 &&
      selectedVertical?.VerticalID === 1
        ? 384
        : selectedPropertyType?.PropertyTypeID === 1 &&
            selectedVertical?.VerticalID === 2
          ? 385
          : selectedPropertyType?.PropertyTypeID === 1 &&
              selectedVertical?.VerticalID === 3
            ? 386
            : selectedPropertyType?.PropertyTypeID === 2 &&
                selectedVertical?.VerticalID === 1
              ? 387
              : 388;

    PostRecords(tabID, 1, postData, (data) => {
      if (data != null && data?.response?.hasErrors === false) {
        //toast.success(`Property Posted Successfully`);
        setPostedID(data?.response?.response?.clientID);
        setOpenSuccess(true);
      } else {
        toast.error(`${data?.response?.errors}`);
      }
    });

    console.log("Post Data:", postData);
  };
  const [selected, setSelected] = useState("Owner");

  const [otp, setOtp] = useState("");
  const [Mobile, setMobile] = useState("");
  const [Name, setName] = useState("");

  const checkMobile = () => {
    if (Mobile.length === 10) {
      setLoading(true);

      let url = `${BaseUrl}/api/DynamicApp/checkMobileUserMongoDynamicV5?AppVersion=1.85&appName=RewardTrail&erpIDprm=0&parentIDprm=${10027}&HideColumns=1&cByPlatform=`;
      let body = {
        baseTokenKey: AUTH_KEY,
        EmailID: "",
        appVersion: "85",
        deviceOS: "android : 15 : VANILLA_ICE_CREAM : sdk=35",
        mobile: Mobile,
        corporateCode: 10027,
        appVersionName: "85",
        deviceCountry: "India",
        deviceID: "",
        deviceName: "",
        imeiNumber: "not found",
        countryCode: "91",
        collectionNumber: "2",
        countryName: "India",
      };

      makeApiRequest(
        url,
        body,
        AUTH_KEY,
        (response) => {
          //  console.log("check mobile response", response);
          if (response.hasErrors == false) {
            let url2 = `${BaseUrl}/api/DynamicApp/mobileSendOtpMongoV5?AppVersion=1.85&appName=${"LandPanda"}&erpIDprm=0&parentIDprm=${10027}&HideColumns=1&cByPlatform=`;
            let body2 = {
              baseTokenKey: AUTH_KEY,
              resend: "0",
              collectionNumber: "2",
              mobile: Mobile,
              corporateCode: 10027,
            };

            makeApiRequest(
              url2,
              body2,
              AUTH_KEY,
              (response2) => {
                if (response2.hasErrors === false) {
                  let decryptedCode = decryptOtp(response2.response);

                  //  console.log("decrypted otp", decryptedCode);

                  let url3 = `${apiUrl_dialerp}/api/DynamicSMS/SendSMS?AppVersion=1.85&appName=${"LandPanda"}&erpIDprm=0&parentIDprm=${10027}&HideColumns=1&cByPlatform=`;
                  let body3 = {
                    Message: `Otp for LandPanda App is ${decryptedCode}\nDIALERP Team`,
                    SubscriberID: 10001,
                    DltEntityID: "1201159187215982418",
                    TemplateDltID: "1007822973245487897",
                    SenderID: "DALERP",
                    CountryCode: "91",
                    userID: "2",
                    Mobile: Mobile,
                  };

                  makeApiRequest(
                    url3,
                    body3,
                    "",
                    (response3) => {
                      //if() console.log("SMS API response", response3);

                      if (response3.hasErrors === false) {
                        setLoading(false);
                        setStepLogin(2);
                      } else {
                        setLoading(false);
                      }
                    },
                    (error3) => {
                      setLoading(false);
                    },
                  );
                } else {
                  setLoading(false);
                }
              },
              (error2) => {
                setLoading(false);
              },
            );
          } else {
            setLoading(false);
            setStepLogin(3);
          }
        },
        (error) => {
          setLoading(false);
        },
      );
    }
  };

  const handleVerify = () => {
    if (otp.length === 4) {
      setLoading(true);
      let url = `${BaseUrl}/api/DynamicApp/mobileLoginVerifyOTPMongoV5`;
      let body = {
        baseTokenKey: AUTH_KEY,
        appVersion: "85",
        deviceOS: "android : 15 : VANILLA_ICE_CREAM : sdk=35",
        mobile: Mobile,
        tabErpID: "753",
        corporateCode: 10027,
        otp: otp,
        appVersionName: "85",
        deviceCountry: "India",
        deviceID: "",
        deviceName: "",
        imeiNumber: "not found",
        countryCode: "91",
        collectionNumber: "2",
        countryName: "India",
      };

      makeApiRequest(
        url,
        body,
        AUTH_KEY,
        (response) => {
          if (response.hasErrors === false && response != null) {
            // onSuccess(response?.response);
            // handleClose();
            // setLoading(false);

            setLogindata(response?.response);
            setlogindata(response?.response);

            localStorage.setItem(
              "loginData",
              JSON.stringify(response?.response),
            );

            getUserDetails(response?.response?.partySr, response?.response);
          } else {
            setLoading(false);
          }
        },
        (error) => {
          setLoading(false);
        },
      );
    }
  };

  const getUserDetails = (userID, data) => {
    getRecords(409, 1, `{UserID: { $in: [${userID}] }}`, 1, "", (response) => {
      // console.log("user details response", response);
      if (response.hasErrors === false) {
        if (response?.response?.records?.length > 0) {
          // onSuccess(data);
          //  onUserDetails(response?.response?.records[0] ?? {});
          // handleClose();
          setUserdata(response?.response?.records[0] ?? {});
          setuserData(response?.response?.records[0] ?? {});
          localStorage.setItem(
            "UserData",
            JSON.stringify(response?.response?.records[0] ?? {}),
          );

          setLoading(false);
        } else {
          setLoading(false);
        }
      } else {
        console.log("Error fetching user details");
        setLoading(false);
      }
    });
  };

  const signup = () => {
    setLoading(true);

    let body = [
      {
        User: Name,
        ProfileID: 3,
        Profile: "Customer",
        Mobile: Mobile,
      },
    ];

    PostRecords(409, 2, body, (response) => {
      //console.log("signup response", response);

      if (response.hasErrors === false) {
        checkMobile();
      } else {
        setLoading(false);
      }
    });
  };

  const IsnextBtnEnabled = () => {
    // STEP 1
    if (step === 1) {
      return (
        selectedCity != null && selectedArea != null && selectedLocality != null
      );
    }

    // STEP 2
    if (step === 2) {
      return (
        selectedPropertyType != null &&
        selectedVertical != null &&
        Selected_ChooseProperty != null
      );
    }

    // STEP 3
    if (step === 3) {
      const isResidential = selectedPropertyType?.PropertyTypeID === 1;
      const isCommercial = selectedPropertyType?.PropertyTypeID === 2;

      const isSale = selectedVertical?.VerticalID === 1;
      const isRent = selectedVertical?.VerticalID === 2;
      const isPG = selectedVertical?.VerticalID === 3;

      const bhkRequired = Selected_ChooseProperty?.BHK === "Y";

      // ---------- PG / Co-living (Residential + Vertical 3) ----------
      if (isResidential && isPG) {
        return (
          PGName !== "" &&
          Noticeperiod !== "" &&
          LockinPeriod !== "" &&
          securityDeposit !== "" &&
          totalBeds !== "" &&
          selectedPGisFor != null &&
          selectedbestSuitedFor != null &&
          selectedMealsAvailable != null &&
          // selectedMealsOfferingData?.length > 0 &&
          selectedCommonAreaData?.length > 0 &&
          selectedRoomTypeData?.length > 0
        );
      }

      // ---------- Sale / Rent (Residential OR Commercial) ----------
      // Common for all Sale/Rent (because Area Unit + Built-up + Price shown when Vertical != 3)
      const commonSaleRent =
        selectedAreaUnit != null && buildupArea !== "" && price !== "";

      // ---------- Rent extra fields (Security Deposit + Available Date) ----------
      const rentExtra = securityDeposit !== "" && availableDt !== "";

      // ---------- Residential Facing required only for Sale/Rent ----------
      const residentialFacingRequired =
        isResidential && (isSale || isRent) ? selectedFacing != null : true;

      // ---------- Commercial extra fields (Expected Return, Hub, Ownership, Pre-rented) ----------
      const commercialExtra =
        isCommercial && (isSale || isRent)
          ? expectedReturn !== "" &&
            selectedlocationHubData != null &&
            selectedownershipData != null &&
            selectedpreRented != null
          : true;

      // ---------- If BHK Required ----------
      if (bhkRequired) {
        const bhkCommon =
          selectedBHK != null &&
          selectedFurnishing != null &&
          // selected_SocietyAmenities?.length > 0 &&
          // selected_PropertyAmenities?.length > 0 &&
          floorNo !== "" &&
          totalFloors !== "" &&
          selectedPropertyAge !== "" &&
          selected_constructionStatus != null;

        // Sale
        if (isSale) {
          return (
            commonSaleRent &&
            bhkCommon &&
            residentialFacingRequired &&
            commercialExtra
          );
        }

        // Rent
        if (isRent) {
          return (
            commonSaleRent &&
            bhkCommon &&
            residentialFacingRequired &&
            commercialExtra &&
            rentExtra
          );
        }

        return false;
      }

      // ---------- If BHK NOT Required ----------
      // Your UI still shows Area Unit + Built-up + Price
      if (isSale) {
        return commonSaleRent && residentialFacingRequired && commercialExtra;
      }

      if (isRent) {
        return (
          commonSaleRent &&
          residentialFacingRequired &&
          commercialExtra &&
          rentExtra
        );
      }

      return false;
    }

    // STEP 4
    if (step === 4) {
      return Description !== "";
    }

    return true;
  };

  // console.log("selected_RoomTypeData:", selectedRoomTypeData);

  return (
    <>
      <div className="page-wrapper">
        <Header />
        <section className="pt-140 pb-75 bg-seashell postproperty">
          <div className="container">
            <div className="row">
              {userData && LoggedInUserID != null && (
                <div className="col-md-3 col-sm-3 d-desk">
                  <div className="card">
                    <h4 className="title tle">
                      {ListingID === "" ? "Post" : "Update"} your property
                    </h4>

                    <div className="stepper">
                      {STEPS.map((label, index) => {
                        const stepNumber = index + 1;
                        return (
                          <div key={label} className="step-item">
                            <div
                              className={`step-dot ${
                                step >= stepNumber ? "active" : ""
                              }`}
                            >
                              {stepNumber}
                            </div>
                            <span
                              className={`step-label ${
                                step === stepNumber ? "current" : ""
                              }`}
                            >
                              {label}
                            </span>
                          </div>
                        );
                      })}
                    </div>

                    <p className="step-text">Need help?</p>
                    <small>
                      Now you can directly{" "}
                      {ListingID === "" ? "post" : "update"} property via
                    </small>
                    <span onClick={()=> toast.info("Coming soon...")} className="Whatsapp">
                      <i className="ri-whatsapp-line" /> Whatsapp
                    </span>
                  </div>
                </div>
              )}

              <div
                className={
                  userData && LoggedInUserID != null
                    ? "col-md-9 col-sm-9 wd100"
                    : "col-md-12 col-sm-12 wd100"
                }
              >
                <div className="stepper d-mobilee">
                  {STEPS.map((label, index) => {
                    const stepNumber = index + 1;
                    return (
                      <div key={label} className="step-item">
                        <div
                          className={`step-dot ${
                            step >= stepNumber ? "active" : ""
                          }`}
                        >
                          {stepNumber}
                        </div>
                        <span
                          className={`step-label ${
                            step === stepNumber ? "current" : ""
                          }`}
                        >
                          {label}
                        </span>
                      </div>
                    );
                  })}
                </div>
                <div className="content card">
                  {step === 1 &&
                    (userData && LoggedInUserID != null ? (
                      <>
                        <h4>Location Details</h4>

                        {/* <div class="form-group">
                      <select
                        value={value}
                        onMouseDown={handleSelectClick}
                        style={{ padding: "10px" }}
                      >
                        <option value="">
                          {value ? value : "Select City"}
                        </option>
                      </select>
                    </div> */}

                        <div class="form-group">
                          <label className="label">
                            City<span className="red">*</span>
                          </label>
                          <select
                            value={selectedCity?.City}
                            onMouseDown={(e) => {
                              e.preventDefault();

                              setdataFlag(1);
                              setOpen(true);
                            }}
                            style={{ padding: "10px" }}
                          >
                            <option value="">
                              {selectedCity?.City
                                ? selectedCity?.City
                                : "Select City"}
                            </option>
                          </select>
                        </div>

                        <div class="form-group">
                          <label className="label">
                            Locality<span className="red">*</span>
                          </label>
                          <select
                            value={selectedLocality?.Locality}
                            //disabled={selectedCity == null}
                            onMouseDown={(e) => {
                              if (selectedCity != null) {
                                e.preventDefault();
                                setdataFlag(2);
                                setOpen(true);
                              } else {
                                //  <Toast title="Please select city first!" />
                                //  alert("Please select city first!");
                                toast.error("Please select city first!");
                              }
                            }}
                            style={{ padding: "10px" }}
                          >
                            <option value="">
                              {selectedLocality?.Locality
                                ? selectedLocality?.Locality
                                : "Select Locality"}
                            </option>
                          </select>
                        </div>

                        <div class="form-group">
                          <label className="label">
                            Street/Building/Area<span className="red">*</span>
                          </label>
                          <select
                            value={selectedArea?.SubArea}
                            //  disabled={selectedLocality == null}
                            onMouseDown={(e) => {
                              if (selectedLocality != null) {
                                e.preventDefault();

                                setdataFlag(3);
                                setOpen(true);
                              } else {
                                toast.error("Please select locality first!");
                              }
                            }}
                            style={{ padding: "10px" }}
                          >
                            <option value="">
                              {selectedArea?.SubArea
                                ? selectedArea?.SubArea
                                : "Select Area"}
                            </option>
                          </select>
                        </div>

                        {/* Dialog */}

                        {open && (
                          <SelectDialog
                            open={open}
                            title="Select City"
                            placeholder="Search City"
                            selectedCity={selectedCity}
                            selectedLocality={selectedLocality}
                            selectedArea={selectedArea}
                            onClose={() => setOpen(false)}
                            dataFlag={dataFlag}
                            setselectedData={setselectedRoomTypeData}
                            onSelect={(option) => {
                              if (dataFlag === 1) setSelectedCity(option);
                              if (dataFlag === 2) setSelectedLocality(option);
                              if (dataFlag === 3) setSelectedArea(option);
                              setOpen(false);
                            }}
                          />
                        )}
                      </>
                    ) : (
                      <Step1
                        PropertyType={PropertyType}
                        selectedPropertyType={selectedPropertyType}
                        setselectedPropertyType={setselectedPropertyType}
                        Vertical={Vertical}
                        selectedVertical={selectedVertical}
                        setselectedVertical={setselectedVertical}
                        otp={otp}
                        setotp={setOtp}
                        Mobile={Mobile}
                        setMobile={setMobile}
                        Name={Name}
                        setName={setName}
                        stepLogin={stepLogin}
                        setStepLogin={setStepLogin}
                        PostedByData={PostedByData}
                        selectedPostedByData={selectedPostedByData}
                        setselectedPostedByData={setselectedPostedByData}
                        onProceed={() => {
                          if (stepLogin == 1) {
                            checkMobile();
                          } else if (stepLogin == 2) {
                            handleVerify();
                          } else if (stepLogin == 3) {
                            signup();
                          }
                        }}
                      />
                    ))}
                  {step === 2 && (
                    <Step2
                      PropertyType={PropertyType}
                      selectedPropertyType={selectedPropertyType}
                      setselectedPropertyType={setselectedPropertyType}
                      Vertical={Vertical}
                      selectedVertical={selectedVertical}
                      setselectedVertical={setselectedVertical}
                      ChooseProperty={ChooseProperty}
                      Selected_ChooseProperty={Selected_ChooseProperty}
                      setSelected_ChooseProperty={setSelected_ChooseProperty}
                      PostedByData={PostedByData}
                      selectedPostedByData={selectedPostedByData}
                      setselectedPostedByData={setselectedPostedByData}
                    />
                  )}
                  {step === 3 && (
                    <Step3
                      BHKData={BHKData}
                      selectedBHK={selectedBHK}
                      setSelectedBHK={setSelectedBHK}
                      AreaunitData={AreaunitData}
                      selectedAreaUnit={selectedAreaUnit}
                      setSelectedAreaUnit={setSelectedAreaUnit}
                      buildupArea={buildupArea}
                      setbuildupArea={setbuildupArea}
                      price={price}
                      setprice={setprice}
                      FurnishingData={FurnishingData}
                      selectedFurnishing={selectedFurnishing}
                      setselectedFurnishing={setselectedFurnishing}
                      SocietyAmenities={SocietyAmenities}
                      selected_SocietyAmenities={selected_SocietyAmenities}
                      setSelected_SocietyAmenities={
                        setSelected_SocietyAmenities
                      }
                      PropertyAmenities={PropertyAmenities}
                      selected_PropertyAmenities={selected_PropertyAmenities}
                      setSelected_PropertyAmenities={
                        setSelected_PropertyAmenities
                      }
                      floorNo={floorNo}
                      setfloorNo={setfloorNo}
                      totalFloors={totalFloors}
                      settotalFloors={settotalFloors}
                      ConstructionStatusData={ConstructionStatusData}
                      selected_constructionStatus={selected_constructionStatus}
                      setselected_constructionStatus={
                        setselected_constructionStatus
                      }
                      facingData={facingData}
                      selectedFacing={selectedFacing}
                      setselectedFacing={setselectedFacing}
                      propertyAgeFields={propertyAgeFields}
                      selectedPropertyAge={selectedPropertyAge}
                      setSelectedPropertyAge={setSelectedPropertyAge}
                      openAmenitiesDialog={openAmenitiesDialog}
                      setOpenAmenitiesDialog={setOpenAmenitiesDialog}
                      dataFlag_Amenities={dataFlag_Amenities}
                      setdataFlag_Amenities={setdataFlag_Amenities}
                      selectedPropertyType={selectedPropertyType}
                      selectedVertical={selectedVertical}
                      Selected_ChooseProperty={Selected_ChooseProperty}
                      securityDeposit={securityDeposit}
                      setsecurityDeposit={setsecurityDeposit}
                      availableDt={availableDt}
                      setAvailableDt={setAvailableDt}
                      locationHubData={locationHubData}
                      setlocationHubData={setlocationHubData}
                      selectedlocationHubData={selectedlocationHubData}
                      setselectedlocationHubData={setselectedlocationHubData}
                      ownershipData={ownershipData}
                      setownershipData={setownershipData}
                      selectedownershipData={selectedownershipData}
                      setselectedownershipData={setselectedownershipData}
                      preRented={preRented}
                      selectedpreRented={selectedpreRented}
                      setselectedpreRented={setselectedpreRented}
                      PGName={PGName}
                      setPGName={setPGName}
                      PGisFor={PGisFor}
                      selectedPGisFor={selectedPGisFor}
                      setselectedPGisFor={setselectedPGisFor}
                      bestSuitedFor={bestSuitedFor}
                      selectedbestSuitedFor={selectedbestSuitedFor}
                      setselectedbestSuitedFor={setselectedbestSuitedFor}
                      MealsAvailable={MealsAvailable}
                      selectedMealsAvailable={selectedMealsAvailable}
                      setselectedMealsAvailable={setselectedMealsAvailable}
                      Noticeperiod={Noticeperiod}
                      setNoticeperiod={setNoticeperiod}
                      LockinPeriod={LockinPeriod}
                      setLockinPeriod={setLockinPeriod}
                      RoomTypeData={RoomTypeData}
                      selectedRoomTypeData={selectedRoomTypeData}
                      setselectedRoomTypeData={setselectedRoomTypeData}
                      MealsOfferingData={MealsOfferingData}
                      selectedMealsOfferingData={selectedMealsOfferingData}
                      setselectedMealsOfferingData={
                        setselectedMealsOfferingData
                      }
                      CommonAreaData={CommonAreaData}
                      selectedCommonAreaData={selectedCommonAreaData}
                      setselectedCommonAreaData={setselectedCommonAreaData}
                      totalBeds={totalBeds}
                      settotalBeds={settotalBeds}
                      expectedReturn={expectedReturn}
                      setexpectedReturn={setexpectedReturn}
                      open={open}
                      setOpen={setOpen}
                      dataFlag={dataFlag}
                      setdataFlag={setdataFlag}
                    />
                  )}
                  {step === 4 && (
                    <Step4
                      Description={Description}
                      setDescription={setDescription}
                      ongenerateAIDescription={async () => {
                        setLoading(true);

                        const postData = {
                          City: selectedCity?.City,
                          CityAlias: selectedCity?.CityAlias,
                          PropertyType: selectedPropertyType?.PropertyType,
                          PropertyTypeID: selectedPropertyType?.PropertyTypeID,
                          Vertical: selectedVertical?.Vertical,
                          VerticalID: selectedVertical?.VerticalID,
                          CityID: selectedCity?.CityID,
                          ChooseProperty:
                            Selected_ChooseProperty?.ChooseProperty,
                          ChoosePropertyID:
                            Selected_ChooseProperty?.ChoosePropertyID,
                          Society: selectedArea?.SubArea,
                          SocietyID: selectedArea?.SubAreaID,
                          Locality: selectedLocality?.Locality,
                          LocalityID: selectedLocality?.LocalityID,
                          State: selectedCity?.State,
                          Country: selectedCity?.Country,

                          BHK: selectedBHK?.BHKUnit,
                          BHKID: selectedBHK?.BHKID,
                          BuiltUpArea: buildupArea,
                          UOMName: selectedAreaUnit?.UOMName,
                          UOMID: selectedAreaUnit?.UOMID,

                          FurnishType: selectedFurnishing?.FurnishType,
                          FurnishID: selectedFurnishing?.FurnishID,

                          ...(selected_PropertyAmenities?.length > 0 && {
                            UnitFurnishingtitle: selected_PropertyAmenities,
                          }),

                          ...(selected_SocietyAmenities?.length > 0 && {
                            PropertyAmenities: selected_SocietyAmenities,
                          }),

                          ...(selectedVertical?.VerticalID == 1 && {
                            Price: formatIndianAmount(parseFloat(price)),
                          }),

                          ConstructionStatus:
                            selected_constructionStatus?.ConstructionStatus,
                          ConstructionStatusID:
                            selected_constructionStatus?.ConstructionStatusID,
                          LocationHub: selectedlocationHubData?.name,
                          LocationHubID: selectedlocationHubData?.id,
                          Ownership: selectedownershipData?.name,
                          OwnershipID: selectedownershipData?.id,
                          Isitpreleasedprerented: selectedpreRented?.name,
                          IsitpreleasedprerentedID: selectedpreRented?.id,
                          PGName: PGName,
                          TotalBeds: totalBeds,
                          PGisfor: selectedPGisFor?.name,
                          BestSuitedfor: selectedbestSuitedFor?.name,
                          MealsAvailable: selectedMealsAvailable?.name,
                          PgisforID: selectedPGisFor?.id,
                          BestSuitedforID: selectedbestSuitedFor?.id,
                          MealsAvailableID: selectedMealsAvailable?.id,
                          CommonArea: selectedCommonAreaData,
                          ...(selectedMealsOfferingData?.length > 0 && {
                            MealsOfferings: selectedMealsOfferingData,
                          }),
                          NoticePeriod: Noticeperiod,
                          LockInPeriod: LockinPeriod,
                          CommonAreas: selectedCommonAreaData,
                          R1_SecurityDeposit: securityDeposit,
                          R1_RoomType: selectedRoomTypeData,

                          ...(selectedVertical?.VerticalID != 1 && {
                            MonthlyRent: price,
                          }),

                          SecurityDeposit: securityDeposit,

                          CarpetArea: "",
                          ExpectedROI: expectedReturn,
                          PropertyAge: selectedPropertyAge?.name,
                          AgeofProperty: selectedPropertyAge?.name,

                          //  Status: "In Review",
                          //  StatusID: "1",

                          TotalFloor: totalFloors,
                          FloorNo: floorNo,
                          Facing: selectedFacing?.name,

                          //  Coordinates: [coordinates?.latitude, coordinates?.longitude],
                        };
                        let AI_input = `${JSON.stringify(postData)} Generate a detailed and engaging SEO friendly property description  for a real estate listing based on the following details in Simple text format with no bullet points and fixed 1300 characters:`;

                        let AI_input_2 = `${JSON.stringify(postData)} Generate a detailed and engaging SEO friendly property Key highlights  for a real estate listing based on the following details in simple Points use CSV comma separated format no special characters with maximum 10 points , i will split this as per , and then display it in frontend to user to give me as per that do not add any kind of numbering just comma separated only  `;

                        const reply = await callAzureOpenAI(AI_input);

                        const reply_ = await callAzureOpenAI(AI_input_2);
                        setLoading(false);
                        setDescription(reply);
                        setKeyHighlights(reply_);
                      }}
                    />
                  )}
                  {step === 5 && <Step5 coordinates={coordinates} />}
                  {step === 6 && (
                    <Step6
                      Selected_ChooseProperty={Selected_ChooseProperty}
                      coverImage={coverImage}
                      setCoverImage={setCoverImage}
                      BathroomImage={BathroomImage}
                      setBathroomImage={setBathroomImage}
                      KitchenImage={KitchenImage}
                      setKitchenImage={setKitchenImage}
                      BedroomImage={BedroomImage}
                      setBedroomImage={setBedroomImage}
                      BalconyImage={BalconyImage}
                      setBalconyImage={setBalconyImage}
                      LivingRoomImage={LivingRoomImage}
                      setLivingRoomImage={setLivingRoomImage}
                      DiningRoomImage={DiningRoomImage}
                      setDiningRoomImage={setDiningRoomImage}
                      ElevationImage={ElevationImage}
                      setElevationImage={setElevationImage}
                      LocalityImage={LocalityImage}
                      setLocalityImage={setLocalityImage}
                      floorPlansImage={floorPlansImage}
                      setfloorPlansImage={setfloorPlansImage}
                      OtherImage={OtherImage}
                      setOtherImage={setOtherImage}
                      Loading={Loading}
                      setLoading={setLoading}
                    />
                  )}
                </div>

                {userData && LoggedInUserID != null && (
                  <div className="footers">
                    <button
                      className="btn secondary"
                      disabled={step === 1}
                      onClick={prevStep}
                    >
                      Previous
                    </button>

                    {step < maxStep ? (
                      <button
                        disabled={!IsnextBtnEnabled()}
                        className="btn primary"
                        onClick={nextStep}
                      >
                        {step === 1 ? "Next Step" : "Next"}
                      </button>
                    ) : (
                      <button
                        onClick={PostPropertyData}
                        className="btn primary"
                      >
                        Submit
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
      {Loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(255,255,255,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <TailSpin color="#00BFFF" height={80} width={80} />
        </div>
      )}

      <SucessDialog
        open={openSuccess}
        onClose={() => setOpenSuccess(false)}
        onSubmit={() => {
          setOpenSuccess(false);
          const tabID =
            selectedPropertyType?.PropertyTypeID === 1 &&
            selectedVertical?.VerticalID === 1
              ? 384
              : selectedPropertyType?.PropertyTypeID === 1 &&
                  selectedVertical?.VerticalID === 2
                ? 385
                : selectedPropertyType?.PropertyTypeID === 1 &&
                    selectedVertical?.VerticalID === 3
                  ? 386
                  : selectedPropertyType?.PropertyTypeID === 2 &&
                      selectedVertical?.VerticalID === 1
                    ? 387
                    : 388;

          navigate(`/property-details?id=${postedID}`, {
            state: {
              TabID: tabID,
            },
          });
        }}
        title={
          ListingID
            ? "Listing Successfully Updated"
            : "Listing Successfully Created"
        }
        message={
          ListingID
            ? `Listing No ${ListingID} has been successfully updated. Thank You!`
            : `Listing No ${postedID} has been successfully created. Thank You!`
        }
        confirmText="OK"
      />
    </>
  );
}

function Step1({
  PropertyType,
  selectedPropertyType,
  setselectedPropertyType,
  Vertical,
  selectedVertical,
  setselectedVertical,
  otp,
  setotp,
  Mobile,
  setMobile,
  Name,
  setName,
  stepLogin,
  setStepLogin,
  PostedByData,
  selectedPostedByData,
  setselectedPostedByData,
  onProceed,
}) {
  const [selected, setSelected] = useState("Owner");
  // const [step, setstep] = useState(1);

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="postpr">
          <div className="row align-items-center gx-5">
            
            <div className="col-md-6 d-none d-md-block">
              <div className="login-bg bg-f">
                <h2>
                  Sell or rent your property
                  <br /> faster with
                  <br /> LandPanda.com
                </h2>
                <ul className="postlist">
                  <li>
                    <i class="ri-checkbox-circle-fill"></i> Post property for
                    free
                  </li>
                  <li>
                    <i class="ri-checkbox-circle-fill"></i> Get verified buyers
                  </li>
                  <li>
                    <i class="ri-checkbox-circle-fill"></i> Get personalised
                    assistance on selling faster
                  </li>
                </ul>

                <div className="agent-info-box">
                  <div className="agent-name-wrap">
                    <div className="agent-img">
                      <img src="assets/img/clients/client-1.jpg" alt="Image" />
                    </div>
                    <div className="agent-name">
                      <h6>
                        Jayden Gabrien
                        <div className="chipps">
                          <span className="property-status">Verified User</span>
                        </div>
                      </h6>
                      <span>Owner • 2 BHK, Delhi</span>
                    </div>
                  </div>

                  <p>
                    Tannu from LandPanda.com was a huge help in getting my
                    property rented out. She was assigned as my relationship
                    manager...<a>View on LinkedIn</a>
                  </p>
                </div>

                <div className="agent-info-box">
                  <div className="agent-name-wrap">
                    <div className="agent-img">
                      <img src="assets/img/clients/client-1.jpg" alt="Image" />
                    </div>
                    <div className="agent-name">
                      <h6>
                        Jayden Gabrien
                        <div className="chipps">
                          <span className="property-status">Verified User</span>
                        </div>
                      </h6>
                      <span>Owner • 2 BHK, Delhi</span>
                    </div>
                  </div>

                  <p>
                    Tannu from LandPanda.com was a huge help in getting my
                    property rented out. She was assigned as my relationship
                    manager...<a>View on LinkedIn</a>
                  </p>
                </div>

                <h4>Why should you list with us</h4>
                <p>
                  Existing user? <a>Login Here</a>
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="login-content">
                <div
                  style={{ display: "flex", gap: "10px" }}
                  className="btntab mb-20"
                >
                  {PostedByData?.map((btn, i) => (
                    <button
                      key={btn.id || i}
                      onClick={() => setselectedPostedByData(btn)}
                      style={{
                        padding: "8px 14px",
                        borderRadius: "6px",
                        border: 0,
                        outline: 0,
                        width: "50%",
                        fontWeight: 600,
                        background:
                          selectedPostedByData?.id === btn.id
                            ? "#059669"
                            : "#f2f2f2",
                        color:
                          selectedPostedByData?.id === btn.id
                            ? "#fff"
                            : "#4b5563",
                      }}
                    >
                      {btn.name}
                    </button>
                  ))}
                </div>
                <div className="agent-info-box">
                  <div className="agent-name-wrap">
                    <div className="agent-img cservice">
                      <i class="ri-customer-service-2-fill"></i>
                    </div>
                    <div className="agent-name cser">
                      <p className="mb-0">
                        Got 2 extra enquiries if you list your property in
                      </p>
                      <span className="chipp">9:54</span>
                    </div>
                  </div>
                </div>
                <label className="blabel">Property Type</label>

                <div style={{ display: "flex", gap: "10px" }} className="mb-20">
                  {PropertyType?.filter(
                    (btn) => btn?.PropertyTypeID === 1,
                  )?.map((btn, i) => (
                    <button
                      key={i}
                      onClick={() => setselectedPropertyType(btn)}
                      style={{
                        padding: "8px 14px",
                        borderRadius: "6px",
                        outline: 0,
                        width: "50%",
                        fontWeight: 600,
                        background:
                          selectedPropertyType?.PropertyTypeID ===
                          btn.PropertyTypeID
                            ? "#f0fdf4"
                            : "#fff",
                        color:
                          selectedPropertyType?.PropertyTypeID ===
                          btn.PropertyTypeID
                            ? "#16a34a"
                            : "#4b5563",
                        borderColor:
                          selectedPropertyType?.PropertyTypeID ===
                          btn.PropertyTypeID
                            ? "#16a34a"
                            : "#4b5563",
                      }}
                    >
                      {btn?.PropertyType}
                    </button>
                  ))}
                </div>

                <label className="blabel">Looking To</label>

                <div style={{ display: "flex", gap: "10px" }} className="mb-20">
                 {[...(Vertical || [])]
                    .filter((btn) => {
                      
                     if(btn?.VerticalID == 2 || btn?.VerticalID == 1) return true
                    
                    })
                    .reverse().map((btn, i) => (
                    <button
                      key={btn.VerticalID || i}
                      type="button"
                      onClick={() => setselectedVertical(btn)}
                      style={{
                        padding: "8px 14px",
                        borderRadius: "6px",
                        outline: 0,
                        width: "50%",
                        fontWeight: 600,
                        background:
                          selectedVertical?.VerticalID === btn.VerticalID
                            ? "#f0fdf4"
                            : "#fff",
                        color:
                          selectedVertical?.VerticalID === btn.VerticalID
                            ? "#16a34a"
                            : "#4b5563",
                        border: `1px solid ${
                          selectedVertical?.VerticalID === btn.VerticalID
                            ? "#16a34a"
                            : "#4b5563"
                        }`,
                      }}
                    >
                      {btn?.Vertical}
                    </button>
                  ))}
                </div>

                <form className="user-form">
                  <div className="row">
                    {stepLogin === 3 && (
                      <div className="col-lg-12">
                        <label className="blabel">Enter your name</label>

                        <div className="form-group">
                          <input
                            onChange={(e) => {
                              setName(e.target.value);
                            }}
                            name="phone"
                            placeholder="Name"
                            required=""
                          />
                        </div>
                      </div>
                    )}

                    <div className="col-lg-12">
                      <label className="blabel">Enter Mobile Number</label>

                      <div className="form-group">
                        <input
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, ""); // digits only
                            if (value.length <= 10) {
                              setMobile(value);
                            }
                          }}
                          value={Mobile}
                          placeholder="Mobile Number"
                          type="tel"
                        />
                      </div>
                    </div>

                    {stepLogin === 2 && (
                      <div className="col-lg-12">
                        <label className="blabel">
                          Enter OTP Sent to Phone {Mobile}
                        </label>

                        <div className="form-group">
                          <input
                            onChange={(e) => {
                              const value = e.target.value.replace(/\D/g, ""); // digits only
                              if (value.length <= 4) {
                                setotp(value);
                              }
                            }}
                            value={otp}
                            //  placeholder="Mobile Number"
                            type="tel"
                            name="phone"
                            placeholder="OTP"
                            required=""
                          />
                        </div>
                      </div>
                    )}

                    <div className="col-lg-12">
                      <div className="form-group">
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            onProceed();
                            // setstep(2);
                          }}
                          className="btn style1"
                        >
                          Proceed
                        </button>
                      </div>
                    </div>
                  </div>
                </form>

                <p className="text-center">
                  Need another way?{" "}
                  <a onClick={()=> toast.info("Coming soon...")}>
                    <b>
                      {" "}
                      <i class="ri-whatsapp-line"></i> Post property via
                      Whatsapp
                    </b>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Step2({
  PropertyType,
  selectedPropertyType,
  setselectedPropertyType,
  Vertical,
  selectedVertical,
  setselectedVertical,
  ChooseProperty,
  Selected_ChooseProperty,
  setSelected_ChooseProperty,
  PostedByData,
  selectedPostedByData,
  setselectedPostedByData,
}) {
  return (
    <>
      <h4>Category & Property Type</h4>

      <label className="label">
        You are ?<span className="red">*</span>
      </label>

      <div style={{ display: "flex", gap: "10px" }} className="btntab mb-20">
        {PostedByData?.map((btn, i) => (
          <button
            key={btn.id || i}
            onClick={() => setselectedPostedByData(btn)}
            style={{
              padding: "8px 14px",
              borderRadius: "6px",
              border: 0,
              outline: 0,
              width: "50%",
              fontWeight: 600,
              background:
                selectedPostedByData?.id === btn.id ? "#16a34a" : "#f2f2f2",
              color: selectedPostedByData?.id === btn.id ? "#fff" : "#4b5563",
            }}
          >
            {btn.name}
          </button>
        ))}
      </div>

      <label className="label">
        Category<span className="red">*</span>
      </label>
      <ButtonGroup
        options={PropertyType}
        selectedoption={selectedPropertyType}
        setselectedoption={setselectedPropertyType}
        selectedPropertyType={selectedPropertyType}
        flag={1}
      />

      <label className="label">
        Looking To<span className="red">*</span>
      </label>
      <ButtonGroup
        options={Vertical}
        selectedoption={selectedVertical}
        setselectedoption={setselectedVertical}
        selectedPropertyType={selectedPropertyType}
        flag={2}
      />

      <label className="label">
        Property Type<span className="red">*</span>
      </label>
      <ButtonGroup
        options={ChooseProperty}
        selectedoption={Selected_ChooseProperty}
        setselectedoption={setSelected_ChooseProperty}
        selectedPropertyType={selectedPropertyType}
        flag={3}
      />
    </>
  );
}

function Step3({
  BHKData,
  selectedBHK,
  setSelectedBHK,
  AreaunitData,
  selectedAreaUnit,
  setSelectedAreaUnit,
  buildupArea,
  setbuildupArea,
  price,
  setprice,
  FurnishingData,
  selectedFurnishing,
  setselectedFurnishing,
  SocietyAmenities,
  selected_SocietyAmenities,
  setSelected_SocietyAmenities,
  PropertyAmenities,
  selected_PropertyAmenities,
  setSelected_PropertyAmenities,
  floorNo,
  setfloorNo,
  totalFloors,
  settotalFloors,
  ConstructionStatusData,
  selected_constructionStatus,
  setselected_constructionStatus,
  facingData,
  selectedFacing,
  setselectedFacing,
  propertyAgeFields,
  selectedPropertyAge,
  setSelectedPropertyAge,
  openAmenitiesDialog,
  setOpenAmenitiesDialog,
  dataFlag_Amenities,
  setdataFlag_Amenities,
  selectedPropertyType,
  selectedVertical,
  Selected_ChooseProperty,
  securityDeposit,
  setsecurityDeposit,
  availableDt,
  setAvailableDt,
  locationHubData,
  setlocationHubData,
  selectedlocationHubData,
  setselectedlocationHubData,
  ownershipData,
  setownershipData,
  selectedownershipData,
  setselectedownershipData,
  preRented,
  selectedpreRented,
  setselectedpreRented,
  PGName,
  setPGName,
  PGisFor,
  selectedPGisFor,
  setselectedPGisFor,
  bestSuitedFor,
  selectedbestSuitedFor,
  setselectedbestSuitedFor,
  MealsAvailable,
  selectedMealsAvailable,
  setselectedMealsAvailable,
  Noticeperiod,
  setNoticeperiod,
  LockinPeriod,
  setLockinPeriod,
  RoomTypeData,
  selectedRoomTypeData,
  setselectedRoomTypeData,
  MealsOfferingData,
  selectedMealsOfferingData,
  setselectedMealsOfferingData,
  CommonAreaData,
  selectedCommonAreaData,
  setselectedCommonAreaData,
  totalBeds,
  settotalBeds,
  expectedReturn,
  setexpectedReturn,
  open,
  setOpen,
  dataFlag,
  setdataFlag,
}) {
  const formatDate = (date) =>
    new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(date);
  const dateRef = useRef(null);

  const [AvailableDtRaw, setAvailableDtRaw] = useState("");

  return (
    <>
      <h4>Property Information</h4>

      {Selected_ChooseProperty?.BHK === "Y" && (
        <div className="form-group">
          <label className="label">
            BHK Type<span className="red">*</span>
          </label>

          <ButtonGroup
            options={BHKData}
            selectedoption={selectedBHK}
            setselectedoption={setSelectedBHK}
            selectedPropertyType={selectedPropertyType}
            flag={4}
          />
        </div>
      )}

      {selectedVertical?.VerticalID !== 3 && (
        <>
          <div className="form-group">
            <label className="label">
              Area Unit<span className="red">*</span>
            </label>
            <ButtonGroup
              options={AreaunitData}
              selectedoption={selectedAreaUnit}
              setselectedoption={setSelectedAreaUnit}
              selectedPropertyType={selectedPropertyType}
              flag={5}
            />
          </div>

          <div className="form-group">
            <label className="label">
              Built-up Area {`(${selectedAreaUnit?.UOMName})`}
              <span className="red">*</span>
            </label>
            <input
              value={buildupArea}
              onChange={(e) => setbuildupArea(e.target.value)}
              className="input"
              placeholder="eg 1250"
            />
          </div>

          <div className="form-group">
            <label
              className="label"
              style={{ display: "block", width: "100%" }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <span>
                  {selectedVertical?.VerticalID == 1 ? "Price" : "Monthly Rent"}{" "}
                  (Rs)
                  <span className="red">*</span>
                </span>

                <span
                  style={{
                    color: "#16a34a",
                    fontWeight: "500",
                    marginRight: "10px",
                  }}
                  className="right-label"
                >
                  ₹{formatIndianAmount(parseInt(price))}
                </span>
              </div>
            </label>

            <input
              value={price}
              onChange={(e) => setprice(e.target.value)}
              className="input"
              placeholder="eg10"
            />
          </div>
        </>
      )}

      {selectedPropertyType?.PropertyTypeID === 1 &&
        selectedVertical?.VerticalID === 3 && (
          <>
            <div className="form-group">
              <label className="label">
                PG Name<span className="red">*</span>
              </label>
              <input
                value={PGName}
                onChange={(e) => setPGName(e.target.value)}
                className="input"
                placeholder="eg Shri Ram PG"
              />
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label className="label">
                    Notice Period (days)<span className="red">*</span>
                  </label>
                  <input
                    value={Noticeperiod}
                    onChange={(e) => setNoticeperiod(e.target.value)}
                    className="input"
                    placeholder="eg 5"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label className="label">
                    Lock In Period (days)<span className="red">*</span>
                  </label>
                  <input
                    value={LockinPeriod}
                    onChange={(e) => setLockinPeriod(e.target.value)}
                    className="input"
                    placeholder="eg 10"
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label className="label">
                    Security Deposit (Rs)<span className="red">*</span>
                  </label>
                  <input
                    value={securityDeposit}
                    onChange={(e) => setsecurityDeposit(e.target.value)}
                    className="input"
                    placeholder="eg 5000"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label className="label">
                    Total Beds<span className="red">*</span>
                  </label>
                  <input
                    value={totalBeds}
                    onChange={(e) => settotalBeds(e.target.value)}
                    className="input"
                    placeholder="eg 3"
                  />
                </div>
              </div>
            </div>

            <div className="form-group">
              <label className="label">
                PG is for<span className="red">*</span>
              </label>
              <ButtonGroup
                options={PGisFor}
                selectedoption={selectedPGisFor}
                setselectedoption={setselectedPGisFor}
                selectedPropertyType={selectedPropertyType}
                flag={12}
              />
            </div>

            <div className="form-group">
              <label className="label">
                Best suited for<span className="red">*</span>
              </label>
              <ButtonGroup
                options={bestSuitedFor}
                selectedoption={selectedbestSuitedFor}
                setselectedoption={setselectedbestSuitedFor}
                selectedPropertyType={selectedPropertyType}
                flag={13}
              />
            </div>

            <div className="form-group">
              <label className="label">
                Meals Available<span className="red">*</span>
              </label>
              <ButtonGroup
                options={MealsAvailable}
                selectedoption={selectedMealsAvailable}
                setselectedoption={setselectedMealsAvailable}
                selectedPropertyType={selectedPropertyType}
                flag={14}
              />
            </div>

            <div class="form-group">
              <label className="label">
                Meals<span className="red">*</span>
              </label>
              <select
                // value={selectedCity?.City}
                onMouseDown={(e) => {
                  e.preventDefault();

                  setdataFlag(4);
                  setOpen(true);
                }}
                style={{ padding: "10px" }}
              >
                <option value="">
                  {selectedMealsOfferingData?.length > 0
                    ? selectedMealsOfferingData
                        ?.map((item) => item.MealOffering)
                        .join(", ")
                    : "Select Meals Offering"}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label className="label">
                Common Areas<span className="red">*</span>
              </label>
              <select
                // value={selectedCity?.City}
                onMouseDown={(e) => {
                  e.preventDefault();

                  setdataFlag(5);
                  setOpen(true);
                }}
                style={{ padding: "10px" }}
              >
                <option value="">
                  {selectedCommonAreaData?.length > 0
                    ? selectedCommonAreaData
                        ?.map((item) => item.CommonArea)
                        .join(", ")
                    : "Select Common Areas"}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label className="label">
                Room Types<span className="red">*</span>
              </label>
              <select
                // value={selectedCity?.City}
                onMouseDown={(e) => {
                  e.preventDefault();

                  setdataFlag(6);
                  setOpen(true);
                }}
                style={{ padding: "10px" }}
              >
                <option value="">
                  {selectedRoomTypeData?.length > 0
                    ? selectedRoomTypeData
                        ?.map((item) => item.RoomType)
                        .join(", ")
                    : "Select Room Types"}
                </option>
              </select>
            </div>
          </>
        )}

      {selectedPropertyType?.PropertyTypeID === 2 &&
        (selectedVertical?.VerticalID === 1 ||
          selectedVertical?.VerticalID === 2) && (
          <>
            <div className="form-group">
              <label className="label">
                {"Expected Return"} (%)
                <span className="red">*</span>
              </label>
              <input
                value={expectedReturn}
                onChange={(e) => setexpectedReturn(e.target.value)}
                className="input"
                placeholder="eg10"
              />
            </div>

            <div className="form-group">
              <label className="label">
                Location Hub<span className="red">*</span>
              </label>
              <ButtonGroup
                options={locationHubData}
                selectedoption={selectedlocationHubData}
                setselectedoption={setselectedlocationHubData}
                selectedPropertyType={selectedPropertyType}
                flag={9}
              />
            </div>

            <div className="form-group">
              <label className="label">
                Ownership<span className="red">*</span>
              </label>
              <ButtonGroup
                options={ownershipData}
                selectedoption={selectedownershipData}
                setselectedoption={setselectedownershipData}
                selectedPropertyType={selectedPropertyType}
                flag={10}
              />
            </div>

            <div className="form-group">
              <label className="label">
                Is it pre-rented ?<span className="red">*</span>
              </label>
              <ButtonGroup
                options={preRented}
                selectedoption={selectedpreRented}
                setselectedoption={setselectedpreRented}
                selectedPropertyType={selectedPropertyType}
                flag={11}
              />
            </div>
          </>
        )}

      {(selectedPropertyType?.PropertyTypeID === 1 ||
        selectedPropertyType?.PropertyTypeID === 2) &&
        selectedVertical?.VerticalID === 2 && (
          <>
            <div className="form-group">
              <label className="label">
                Security Deposit (Rs)<span className="red">*</span>
              </label>
              <input
                value={securityDeposit}
                onChange={(e) => setsecurityDeposit(e.target.value)}
                className="input"
                placeholder="eg1000"
              />
            </div>

            <div className="form-group">
              <label className="label">
                Available From<span className="red">*</span>
              </label>

              <input
                type="text"
                className="input"
                readOnly
                value={`📅 ${availableDt}`}
                onClick={() => dateRef.current.showPicker()}
              />

              <input
                type="date"
                ref={dateRef}
                style={{
                  position: "absolute",
                  width: 0,
                  height: 0,
                  opacity: 0,
                  border: "none",
                  padding: 0,
                  margin: 0,
                }}
                onChange={(e) =>
                  setAvailableDt(formatDate(new Date(e.target.value)))
                }
              />
            </div>

            {/* <div
              className="date-row"
              onClick={() => dateRef.current.showPicker()}
            >
              <span className="icon">📅</span>

              <span className="date-text">{availableDt}</span>

              <span className="spacer" />

              <span className="icon">▾</span>

              <input
                type="date"
                ref={dateRef}
                min={new Date().toISOString().split("T")[0]}
                onChange={(e) =>
                  setAvailableDt(formatDate(new Date(e.target.value)))
                }
                style={{
                  position: "absolute",
                  width: 0,
                  height: 0,
                  opacity: 0,
                  border: "none",
                  padding: 0,
                  margin: 0,
                }}
              />
            </div> */}
          </>
        )}

      {Selected_ChooseProperty?.BHK === "Y" && (
        <>
          <div className="form-group">
            <label className="label">
              Furnishing<span className="red">*</span>
            </label>
            <ButtonGroup
              options={FurnishingData}
              selectedoption={selectedFurnishing}
              setselectedoption={setselectedFurnishing}
              selectedPropertyType={selectedPropertyType}
              flag={6}
            />
          </div>

          <div class="form-group">
            <label className="label">
              Society Amenities
            </label>
            <select
              onMouseDown={(e) => {
                e.preventDefault();
                setdataFlag_Amenities(1);

                setOpenAmenitiesDialog(true);
              }}
              name="category"
              id="category"
            >
              <option value="">
                {selected_SocietyAmenities?.length > 0
                  ? selected_SocietyAmenities
                      ?.map((item) => item.PropertyAmenities)
                      .join(", ")
                  : "Select Society Amenities"}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label className="label">
              Property Furnishing
            </label>
            <select
              onMouseDown={(e) => {
                e.preventDefault();
                setdataFlag_Amenities(2);

                setOpenAmenitiesDialog(true);
              }}
              name="category"
              id="category"
            >
              <option value="">
                {selected_PropertyAmenities?.length > 0
                  ? selected_PropertyAmenities
                      ?.map((item) => item.UnitFurnishing)
                      .join(", ")
                  : "Select Property Furnishing"}
              </option>
            </select>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label className="label">
                  Floor No.<span className="red">*</span>
                </label>
                <input
                  value={floorNo}
                  onChange={(e) => setfloorNo(e.target.value)}
                  className="input"
                  placeholder="eg 1"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="label">
                  Total Floors<span className="red">*</span>
                </label>
                <input
                  value={totalFloors}
                  onChange={(e) => settotalFloors(e.target.value)}
                  className="input"
                  placeholder="eg 10"
                />
              </div>
            </div>
          </div>

          <div class="form-group">
            <label className="label">
              Property Age<span className="red">*</span>
            </label>
            <select
              name="category"
              id="category"
              value={selectedPropertyAge}
              onChange={(e) => setSelectedPropertyAge(e.target.value)}
            >
              {propertyAgeFields?.map((option) => (
                <option key={option.id} value={option.name}>
                  {option.name}
                </option>
              ))}
            </select>
          </div>
        </>
      )}

      {selectedPropertyType?.PropertyTypeID === 1 &&
        (selectedVertical?.VerticalID === 1 ||
          selectedVertical?.VerticalID === 2) && (
          <div className="form-group">
            <label className="label">
              Facing<span className="red">*</span>
            </label>
            <ButtonGroup
              options={facingData}
              selectedoption={selectedFacing}
              setselectedoption={setselectedFacing}
              selectedPropertyType={selectedPropertyType}
              flag={7}
            />
          </div>
        )}

      {Selected_ChooseProperty?.BHK === "Y" && (
        <div className="form-group">
          <label className="label">
            Construction Satus<span className="red">*</span>
          </label>
          <ButtonGroup
            options={ConstructionStatusData}
            selectedoption={selected_constructionStatus}
            setselectedoption={setselected_constructionStatus}
            selectedPropertyType={selectedPropertyType}
            flag={8}
          />
        </div>
      )}

      {openAmenitiesDialog && (
        <AmenitiesDialog
          AmenitiesData={
            dataFlag_Amenities === 1 ? SocietyAmenities : PropertyAmenities
          }
          selectedData={
            dataFlag_Amenities === 1
              ? selected_SocietyAmenities
              : selected_PropertyAmenities
          }
          flag={dataFlag_Amenities}
          setselectedData={
            dataFlag_Amenities === 1
              ? setSelected_SocietyAmenities
              : setSelected_PropertyAmenities
          }
          onClose={() => setOpenAmenitiesDialog(false)}
          onSelect={(data) => {
            if (dataFlag_Amenities === 1) {
              setSelected_SocietyAmenities((prev) => {
                const exists = prev.some(
                  (item) =>
                    item.PropertyAmenitiesID === data.PropertyAmenitiesID,
                );

                if (exists) {
                  // remove
                  return prev.filter(
                    (item) =>
                      item.PropertyAmenitiesID !== data.PropertyAmenitiesID,
                  );
                }

                // add
                return [...prev, data];
              });
            } else if (dataFlag_Amenities === 2) {
              setSelected_PropertyAmenities((prev) => {
                const exists = prev.find(
                  (item) => item.UnitFurnishingID === data.UnitFurnishingID,
                );

                // ✅ CASE 1: Count === "Y" → Quantity logic
                if (data.Count === "Y") {
                  if (exists) {
                    // increase quantity
                    return prev.map((item) =>
                      item.UnitFurnishingID === data.UnitFurnishingID
                        ? { ...item, Quantity: item.Quantity + 1 }
                        : item,
                    );
                  }

                  // add with Quantity = 1
                  return [...prev, { ...data, Quantity: 1 }];
                }

                // ✅ CASE 2: Count !== "Y" → Toggle logic
                if (exists) {
                  // remove if already selected
                  return prev.filter(
                    (item) => item.UnitFurnishingID !== data.UnitFurnishingID,
                  );
                }

                // add normally (no quantity needed)
                return [...prev, { ...data, Quantity: 1 }];
              });
            }
          }}
        />
      )}

      {open && (
        <SelectDialog
          open={open}
          title="Select City"
          placeholder="Search"
          selectedCity={{}}
          selectedLocality={{}}
          selectedArea={
            dataFlag === 4
              ? selectedMealsOfferingData
              : dataFlag === 5
                ? selectedCommonAreaData
                : dataFlag === 6
                  ? selectedRoomTypeData
                  : selectedMealsOfferingData
          }
          onClose={() => setOpen(false)}
          dataFlag={dataFlag}
          setselectedData={setselectedRoomTypeData}
          onSelect={(data) => {
            if (dataFlag === 4)
              setselectedMealsOfferingData((prev) => {
                const exists = prev.some((item) => item.ID === data.ID);

                if (exists) {
                  // remove
                  return prev.filter((item) => item.ID !== data.ID);
                }

                // add
                return [...prev, data];
              });

            if (dataFlag === 5)
              setselectedCommonAreaData((prev) => {
                const exists = prev.some((item) => item.ID === data.ID);

                if (exists) {
                  // remove
                  return prev.filter((item) => item.ID !== data.ID);
                }

                // add
                return [...prev, data];
              });
            if (dataFlag === 6)
              setselectedRoomTypeData((prev) => {
                const exists = prev.some((item) => item.ID === data.ID);

                if (exists) {
                  // remove
                  return prev.filter((item) => item.ID !== data.ID);
                }

                // add
                return [...prev, data];
              });
            // setOpen(false);
          }}
        />
      )}

      {/* <div class="form-group">
        <label className="label">
          Location Hub<span className="red">*</span>
        </label>
        <ButtonGroup
          options={[
            "North",
            "South",
            "East",
            "West",
            "North-East",
            "North-West",
            "South-East",
            "South-West",
          ]}
        />
      </div> */}
    </>
  );
}

function Step4({ Description, setDescription, ongenerateAIDescription }) {
  return (
    <>
      <h4>Basic Details</h4>

      <div className="form-group">
        <label className="label">
          Description<span className="red">*</span>
        </label>

        <textarea
          className="textarea"
          placeholder="Describe your property features, facilities, and amenities etc."
          value={Description}
          onChange={(e) => setDescription(e.target.value)}
        />

        {/* Button below textarea */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "6px",
          }}
        >
          <button
            type="button"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              background:
                "linear-gradient(90deg, rgba(79,70,229,1) 0%, rgba(99,102,241,1) 100%)",
              "&:hover": {
                background:
                  "linear-gradient(90deg, rgba(67,56,202,1) 0%, rgba(79,70,229,1) 100%)",
              },
              color: "#ffffff",
              border: "none",
              borderRadius: "10px",
              padding: "10px 20px",
              fontSize: "14px",
              fontWeight: "500",
              cursor: "pointer",
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            }}
            onClick={() => {
              ongenerateAIDescription();
            }}
          >
            <span style={{ fontSize: "14px" }}>🤖</span>
            Generate with AI
          </button>
        </div>
      </div>
    </>
  );
}

function Step6({
  Selected_ChooseProperty,
  coverImage,
  setCoverImage,
  BathroomImage,
  setBathroomImage,
  KitchenImage,
  setKitchenImage,
  BedroomImage,
  setBedroomImage,
  BalconyImage,
  setBalconyImage,
  LivingRoomImage,
  setLivingRoomImage,
  DiningRoomImage,
  setDiningRoomImage,
  ElevationImage,
  setElevationImage,
  LocalityImage,
  setLocalityImage,
  floorPlansImage,
  setfloorPlansImage,
  OtherImage,
  setOtherImage,
  Loading,
  setLoading,
}) {
  const sections =
    Selected_ChooseProperty?.BHK === "Y"
      ? [
          { title: "Cover Images", value: coverImage, setter: setCoverImage },
          {
            title: "Bathroom Images",
            value: BathroomImage,
            setter: setBathroomImage,
          },
          {
            title: "Kitchen Images",
            value: KitchenImage,
            setter: setKitchenImage,
          },
          {
            title: "Bedroom Images",
            value: BedroomImage,
            setter: setBedroomImage,
          },
          {
            title: "Balcony Images",
            value: BalconyImage,
            setter: setBalconyImage,
          },
          {
            title: "Living Room Images",
            value: LivingRoomImage,
            setter: setLivingRoomImage,
          },
          {
            title: "Dining Room Images",
            value: DiningRoomImage,
            setter: setDiningRoomImage,
          },
          {
            title: "Elevation Images",
            value: ElevationImage,
            setter: setElevationImage,
          },
          {
            title: "Locality Images",
            value: LocalityImage,
            setter: setLocalityImage,
          },
          {
            title: "Floor Plans Images",
            value: floorPlansImage,
            setter: setfloorPlansImage,
          },
          { title: "Other Images", value: OtherImage, setter: setOtherImage },
        ]
      : [{ title: "Cover Images", value: coverImage, setter: setCoverImage }];

  return (
    <>
      {sections.map((section, index) => (
        <ImageSection
          key={index}
          title={section.title}
          imagesCSV={section.value}
          setImagesCSV={section.setter}
          Loading={Loading}
          setLoading={setLoading}
        />
      ))}
    </>
  );
}

function Step5({ coordinates }) {
  return (
    <>
      <h4>Location Information</h4>

      <div class="form-group">
        <input className="input" placeholder="Search location" />
      </div>
      <div className="map-placeholder">
        <iframe
          src={`https://www.google.com/maps?q=${coordinates?.latitude},${coordinates?.longitude}&hl=en&z=15&output=embed`}
          width="100%"
          height="100%"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </>
  );
}

function ImageSection({ title, imagesCSV, setImagesCSV, Loading, setLoading }) {
  const images = imagesCSV ? imagesCSV.split(",").filter(Boolean) : [];

  const handleUpload = async (e) => {
    setLoading(true);
    const urls = await uploadMultipleFiles({
      files: Array.from(e.target.files),
    });

    if (!urls.length) {
      setLoading(false);
      return;
    }

    setImagesCSV([...images, ...urls].join(","));
    setLoading(false);
  };

  const AddBox = () => (
    <label
      style={{
        height: "150px",
        border: "2px dashed #cbd5e1",
        borderRadius: "12px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#f8fafc",
        color: "#64748b",
        cursor: "pointer",
      }}
    >
      <span style={{ fontSize: "14px", fontWeight: "600" }}>Add Image</span>
      <small style={{ fontSize: "12px", marginTop: "4px" }}>JPG / PNG</small>
      <input
        type="file"
        multiple
        accept="image/*"
        hidden
        onChange={handleUpload}
      />
    </label>
  );

  return (
    <>
      <h4 style={{ marginTop: 10 }}>{title}</h4>

      {images.length === 0 ? (
        <div style={{ marginTop: "12px" }}>
          <AddBox />
        </div>
      ) : (
        <div
          style={{
            marginTop: "12px",
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "12px",
          }}
        >
          {images.map((img, i) => (
            <img
              key={i}
              src={img}
              alt={title}
              style={{
                width: "100%",
                height: "150px",
                objectFit: "cover",
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              }}
            />
          ))}
          <AddBox />
        </div>
      )}
    </>
  );
}

function ButtonGroup({
  options,
  selectedoption,
  setselectedoption,
  selectedPropertyType,
  flag,
}) {
  // const [active, setActive] = useState(options[0]);
  // console.log("options", options);

  const getOptionLabel = (option) => {
    if (flag === 1) {
      return option?.PropertyType;
    } else if (flag === 2) {
      return option.Vertical;
    } else if (flag === 3) {
      return option?.ChooseProperty;
    } else if (flag === 4) {
      return option?.BHKUnit;
    } else if (flag === 5) {
      return option?.UOMName;
    } else if (flag === 6) {
      return option?.FurnishType;
    } else if (flag === 7) {
      return option?.name;
    } else if (flag === 8) {
      return option?.ConstructionStatus;
    } else if (flag === 9) {
      return option?.name;
    } else if (flag === 10) {
      return option?.name;
    } else if (flag === 11) {
      return option?.name;
    } else if (flag === 12) {
      return option?.name;
    } else if (flag === 13) {
      return option?.name;
    } else if (flag === 14) {
      return option?.name;
    } else {
      return option?.PropertyType;
    }
  };

  const IsSelected = (option) => {
    if (flag === 1) {
      return selectedoption?.PropertyTypeID === option?.PropertyTypeID;
    } else if (flag === 2) {
      return selectedoption?.VerticalID === option.VerticalID;
    } else if (flag === 3) {
      return selectedoption?.ChoosePropertyID === option?.ChoosePropertyID;
    } else if (flag === 4) {
      return selectedoption?.BHKID === option?.BHKID;
    } else if (flag === 5) {
      return selectedoption?.UOMID === option?.UOMID;
    } else if (flag === 6) {
      return selectedoption?.FurnishID === option?.FurnishID;
    } else if (flag === 7) {
      return selectedoption?.name === option?.name;
    } else if (flag === 8) {
      return selectedoption?.ConstructionStatus === option?.ConstructionStatus;
    } else if (flag === 9) {
      return selectedoption?.name === option?.name;
    } else if (flag === 10) {
      return selectedoption?.name === option?.name;
    } else if (flag === 11) {
      return selectedoption?.name === option?.name;
    } else if (flag === 12) {
      return selectedoption?.name === option?.name;
    } else if (flag === 13) {
      return selectedoption?.name === option?.name;
    } else if (flag === 14) {
      return selectedoption?.name === option?.name;
    } else {
      return selectedoption?.PropertyTypeID === option?.PropertyTypeID;
    }
  };

  const filteredOptions =
  flag === 1
    ? options?.filter((opt) => opt?.PropertyTypeID === 1)
    : flag === 2
      ? options
          ?.filter(
            (opt) => opt?.VerticalID === 1 || opt?.VerticalID === 2
          )
          ?.reverse()
      : options;   // ✅ show all for other flags

  return (
    <div className="btn-group">
      {filteredOptions?.map((opt, i) => (
        <button
          key={i}
          className={`option ${IsSelected(opt) ? "selected" : ""}`}
          onClick={() => setselectedoption(opt)}
          style={{ display: "flex", alignItems: "center", gap: "8px" }}
        >
          {flag === 3 && (
            <img
              src={opt.ChoosePropertyIcon}
              alt=""
              style={{ width: "25px", height: "25px" }}
            />
          )}
          <span>{getOptionLabel(opt)}</span>
        </button>
      ))}
    </div>
  );
}

export default PostProperty;
